import { render, staticRenderFns } from "./ScheduledCall.vue?vue&type=template&id=bdc2716e&"
import script from "./ScheduledCall.vue?vue&type=script&lang=js&"
export * from "./ScheduledCall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports